import PerfilService from "@/services/PerfilService"

export const actions = {
    cadastrarPerfil: ({commit, dispatch}) => {
        commit('setPerfil', {}),
        commit('setPerfilPermissoesSelecionadas', [])
        dispatch('setModalCadastroPerfil', true)
    },
    listarPerfil: ({commit}, data) => {
        commit('setOverlay', true)
        PerfilService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setPerfis', res.data)

        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarPerfil: ({commit, dispatch}, data) => {
        commit('setPerfil', data)
        commit('setPerfilPermissoesSelecionadas', [])
        data.permissoes.forEach(e => {
            commit('addPermissaoSelecionada', e.id)
        })
        dispatch('setModalCadastroPerfil', true)
    },
    
    salvarPerfil: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        PerfilService.salvar(data)
        .then(res => {
            commit('setPerfil', res.data)
            commit('addPerfil', res.data)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Perfil cadastrado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrado.')
        })
    },
    atualizarPerfil: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        PerfilService.atualizar(data)
        .then(res => {
            dispatch('listarPerfil')
            commit('setOverlay', false)
            commit('snackbarInfo', 'Perfil atualizado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirPerfil: ({commit, dispatch}, data) => {
        dispatch('setModalExcluirPerfil', false)
        dispatch('setModalCadastroPerfil', false)
        commit('setOverlay', true)
        PerfilService.excluir(data.id)
        .then(res => {
            commit('removePerfil', res.data)
            commit('setOverlay', false)
            commit('snackbarError', 'Perfil excluído.')
        })
        .catch(e => {
            commit('snackbarError', 'Erro ao atualizar cliente.')
        })
    },
    setModalCadastroPerfil: ({commit}, status) => {
        commit('setModalCadastrarPerfil', false)
        setTimeout(() => {
            commit('setModalCadastrarPerfil', status)
        }, 100);
    },
    setModalExcluirPerfil: ({commit}, status) => {
        commit('setModalExcluirPerfil', false)
        setTimeout(() => {
            commit('setModalExcluirPerfil', status)
        }, 100);
    },
}

export default {}